import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  OnInit, ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';

import { PreferencesService } from 'shared/preferences/preferences.service';
import { AccountInformationService } from '../../account-information.service';
import { InformationPageService } from '../../../information-page/information-page.service';


import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { PreferencesFormComponent } from './preferences-form.component';

import { PREFERENCES_NAME } from '../../variables';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';

@Component({
  moduleId: module.id,
  selector: 'preferences-segment',
  template: `
    <preferences-form
      [data]='data'
      [segmentData]='segmentData'
      (save)='onSave($event)'
    ></preferences-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PreferencesComponent extends BaseAccountSegmentComponent implements OnInit {
  name: string = PREFERENCES_NAME;
  declare data: any;

  @ViewChild(PreferencesFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: PreferencesFormComponent | void;

  constructor(
    protected preferencesService: PreferencesService,
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected ref: ChangeDetectorRef,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get isAllowedToSave(): boolean {
    // don't allow to save if form is invalid
    return this.form && this.form.valid;
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  // redefined method of BaseAccountSegmentComponent
  fetchFormData(): Observable<any> {
    return this.preferencesService.getPreferences();
  }

  // redefined method of BaseAccountSegmentComponent
  putFormData(): Observable<any> {
    if (!this.formComponent) {
      return;
    }
    const data = this.formComponent.form.value;
    return this.preferencesService.putPreferences(data);
  }
}
